import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../lib/queryKeys';
import { fetchBoardStats } from '../api/leads';

/**
 * Board stats (total, active, completed, inbox).
 */
export function useBoardStats (enabled = true) {
  return useQuery({
    queryKey: queryKeys.leads.boardStats(),
    queryFn: fetchBoardStats,
    enabled,
  });
}
